<template>
  <v-btn v-bind="buttonProps" :style="buttonStyle" @click="handleGoBack">
    <v-icon v-if="showIcon" :left="!iconOnly" style="color: inherit !important;">{{ icon }}</v-icon>
    <span v-if="!iconOnly" style="color: inherit !important;">{{ displayText }}</span>
  </v-btn>
</template>

<script>
export default {
  name: "GoBackButton",
  props: {
    text: {
      type: String,
      default: "Back",
    },
    icon: {
      type: String,
      default: "mdi-chevron-left",
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
    iconOnly: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: "small",
      validator: (value) =>
        ["x-small", "small", "default", "large", "x-large"].includes(value),
    },

    color: {
      type: String,
      default: "primary",
    },
    outlined: Boolean,
    textButton: Boolean,
    elevation: {
      type: [Number, String],
      default: 0,
    },
    disabled: Boolean,

    to: {
      type: [String, Object],
      default: null,
    },
    logActivity: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    displayText() {
      return this.text;
    },

    buttonProps() {
      const props = {
        color: this.color,
        outlined: this.outlined,
        text: this.textButton,
        elevation: this.elevation,
        disabled: this.disabled,
      };

      if (this.size === "x-small") props.xSmall = true;
      else if (this.size === "small") props.small = true;
      else if (this.size === "large") props.large = true;
      else if (this.size === "x-large") props.xLarge = true;

      return props;
    },

    buttonStyle() {
      return {
        backgroundColor: (this.outlined || this.textButton ? 'transparent' : '#1976d2') + ' !important',
        color: (this.outlined || this.textButton ? '#1976d2' : 'white') + ' !important',
        border: (this.outlined ? '1px solid #1976d2' : 'none') + ' !important'
      };
    },
  },

  methods: {
    handleGoBack() {
      this.$emit("click");

      if (this.to) {
        // Navigate to specific route
        if (typeof this.to === 'string') {
          this.$router.push({ name: this.to });
        } else {
          this.$router.push(this.to);
        }
        return;
      }

      if (this.$router && window.history.length > 1) {
        this.$router.go(-1);
      } else {
        this.$router.push({ name: 'home' });
      }

      if (this.logActivity) {
        this.$emit('activity-logged', {
          activityType: 'clicked_menu_back',
          component: 'GoBackButton'
        });
      }
    },
  },
};
</script>
